<template>
  <div class="invite-page">
    <div class="invite-header">
      <div class="back-icon" @click="goBack">
        <span class="back-arrow"></span>
      </div>
      <div class="invite-title">邀请好友</div>
    </div>

    <div class="invite-content">
      <div class="progress-card">
        <div class="progress-title">邀请进度</div>
        <div class="progress-value">{{ progressText }}</div>
        <div class="progress-desc">{{ progressDesc }}</div>
        <div class="progress-bar">
          <div class="progress-bar-inner" :style="{ width: progressPercent + '%' }"></div>
        </div>
        <div class="quota-row">
          <div class="quota-item">
            <div class="quota-label">有效邀请</div>
            <div class="quota-number">{{ progress.effectiveCount || 0 }}</div>
          </div>
          <div class="quota-item">
            <div class="quota-label">剩余次数</div>
            <div class="quota-number">{{ progress.isUnlimited ? '无限' : (progress.remainingQuota || 0) }}</div>
          </div>
        </div>
      </div>

      <div class="qrcode-card">
        <div class="card-title">分享公众号二维码</div>
        <div class="qrcode-wrap">
          <img v-if="qrCodeImageUrl" :src="qrCodeImageUrl" alt="邀请二维码" class="qrcode-image" />
          <div v-else class="qrcode-placeholder">二维码生成中</div>
        </div>
        <div class="qrcode-tip">保存图片或截图发送给微信好友，好友关注并进入公众号后即可完成邀请。</div>
      </div>

      <div class="invite-list-card">
        <div class="card-title">已邀请用户</div>
        <div v-if="inviteeList.length" class="invitee-list">
          <div v-for="item in inviteeList" :key="item.userId + '-' + item.registerTime" class="invitee-item">
            <div class="invitee-avatar">
              <img v-if="item.img" :src="item.img" class="invitee-avatar-img" />
              <van-icon v-else name="user-circle-o" size="26" color="#1566C1" />
            </div>
            <div class="invitee-info">
              <div class="invitee-name">{{ item.name || '匿名用户' }}</div>
              <div class="invitee-time">{{ formatDateTime(item.registerTime) }}</div>
            </div>
            <div class="invitee-status" :class="item.isValid ? 'is-valid' : 'is-invalid'">
              {{ item.isValid ? '有效' : '待确认' }}
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <van-icon name="friends-o" size="48" color="#c8c9cc" />
          <div class="empty-text">暂时还没有邀请记录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { getInviteProgress } from '@/api/invite';

export default {
  name: 'InvitePage',
  data() {
    return {
      loading: false,
      progress: {
        effectiveCount: 0,
        remainingQuota: 0,
        isUnlimited: false,
        qrCode: null,
        inviteeList: [],
      },
    };
  },
  computed: {
    inviteeList() {
      return this.progress.inviteeList || [];
    },
    progressPercent() {
      if (this.progress.isUnlimited) {
        return 100;
      }
      const value = Number(this.progress.effectiveCount || 0);
      return Math.min(100, Math.max(0, (value / 3) * 100));
    },
    progressText() {
      if (this.progress.isUnlimited) {
        return '已解锁无限使用';
      }
      return `${this.progress.effectiveCount || 0} / 3`;
    },
    progressDesc() {
      if (this.progress.isUnlimited) {
        return '你已解锁无限查询次数';
      }
      const remain = Math.max(0, 3 - Number(this.progress.effectiveCount || 0));
      return remain === 0 ? '已满足解锁条件，系统将在数据同步后更新状态' : `再邀请 ${remain} 人即可解锁无限使用`;
    },
    qrCodeImageUrl() {
      const ticket = this.progress && this.progress.qrCode && this.progress.qrCode.ticket;
      if (!ticket) {
        return '';
      }
      return `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${encodeURIComponent(ticket)}`;
    },
  },
  created() {
    this.loadInviteProgress();
  },
  methods: {
    loadInviteProgress() {
      this.loading = true;
      getInviteProgress()
        .then((res) => {
          this.progress = (res && res.data && res.data.data) || this.progress;
        })
        .catch((error) => {
          Toast(error.message || '获取邀请信息失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDateTime(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
.invite-page {
  min-height: 100vh;
  background: #F5F7FF;
}

.invite-header {
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
  height: 52px;
  padding: 0 12px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.back-icon {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
}

.back-arrow {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-left: 2px solid #333;
  border-bottom: 2px solid #333;
  transform: rotate(45deg);
}

.invite-title {
  flex: 1;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  color: #0D1B3E;
  margin-right: 36px;
}

.invite-content {
  padding: 16px;
}

.progress-card,
.qrcode-card,
.invite-list-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 18px 16px;
  margin-bottom: 16px;
}

.progress-title,
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #0D1B3E;
}

.progress-value {
  margin-top: 12px;
  font-size: 28px;
  font-weight: 700;
  color: #1566C1;
}

.progress-desc {
  margin-top: 8px;
  font-size: 13px;
  color: #60708F;
}

.progress-bar {
  margin-top: 14px;
  height: 10px;
  border-radius: 999px;
  background: #E7EEF9;
  overflow: hidden;
}

.progress-bar-inner {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #1566C1 0%, #3D8BFF 100%);
}

.quota-row {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.quota-item {
  flex: 1;
  padding: 12px;
  border-radius: 12px;
  background: #F5F7FF;
}

.quota-label {
  font-size: 12px;
  color: #6A7A99;
}

.quota-number {
  margin-top: 6px;
  font-size: 20px;
  font-weight: 700;
  color: #1566C1;
}

.qrcode-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
}

.qrcode-image {
  width: 220px;
  height: 220px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #E7EEF9;
}

.qrcode-placeholder {
  width: 220px;
  height: 220px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F5F7FF;
  color: #8A97B3;
  border: 1px solid #E7EEF9;
}

.qrcode-tip {
  margin-top: 14px;
  font-size: 13px;
  line-height: 1.7;
  color: #60708F;
  text-align: center;
}

.invitee-list {
  margin-top: 14px;
}

.invitee-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #EEF2FA;
}

.invitee-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.invitee-avatar {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  overflow: hidden;
  background: #F5F7FF;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.invitee-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.invitee-info {
  flex: 1;
  min-width: 0;
}

.invitee-name {
  font-size: 14px;
  font-weight: 500;
  color: #0D1B3E;
}

.invitee-time {
  margin-top: 4px;
  font-size: 12px;
  color: #8A97B3;
}

.invitee-status {
  flex-shrink: 0;
  min-width: 52px;
  height: 26px;
  padding: 0 10px;
  border-radius: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

.is-valid {
  background: rgba(21, 102, 193, 0.10);
  color: #1566C1;
}

.is-invalid {
  background: rgba(198, 40, 40, 0.10);
  color: #C62828;
}

.empty-state {
  padding: 32px 16px 16px;
  text-align: center;
}

.empty-text {
  margin-top: 12px;
  font-size: 13px;
  color: #8A97B3;
}
</style>
